import store from '@/store'

const resetStore = async function(): Promise<void> {
  store.commit('auth/reset')
  store.commit('moderatorPreferences/reset')
  store.commit('posts/reset')
  store.commit('tags/reset')
  store.commit('townMemberships/reset')
  store.commit('towns/reset')
  store.commit('users/reset')
}

export default resetStore
